// libs
import React, { memo } from 'react';
// widgets
import Line from '@/widgets/Line';
import WeekSelector from './widgets/Week';
import DateSelector from './widgets/Date';
import TimeSlotSelector from './widgets/TimeSlot';
// constants
import { DAY_OF_WEEK_OPTIONS, MEAL_SLOT_OPTIONS } from '@/constants/Misc';
function SchedulePref({ campaignStatus, currentCampaignEndDate, campaignStartDate, setCampaignStartDate, campaignEndDate, setCampaignEndDate, mealSlots, setMealSlots, daysOfWeek, setDaysOfWeek, validationMessages, }) {
    return (React.createElement(React.Fragment, null,
        React.createElement(DateSelector, { currentCampaignEndDate: currentCampaignEndDate, campaignStatus: campaignStatus, campaignStartDate: campaignStartDate, campaignEndDate: campaignEndDate, setCampaignStartDate: setCampaignStartDate, setCampaignEndDate: setCampaignEndDate, validationMessages: validationMessages }),
        React.createElement(Line, null),
        React.createElement(WeekSelector, { options: DAY_OF_WEEK_OPTIONS, daysOfWeek: daysOfWeek, setDaysOfWeek: setDaysOfWeek, validationMessages: validationMessages }),
        React.createElement(Line, null),
        React.createElement(TimeSlotSelector, { options: MEAL_SLOT_OPTIONS, mealSlots: mealSlots, setMealSlots: setMealSlots, validationMessages: validationMessages })));
}
export default memo(SchedulePref);
